module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-8-a01ca1b9e15d917915e2d03afb685ee6.jpg";